<template>
  <div class="align-start item-topic">
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_86_112)">
        <path
          d="M4.51999 9.50667C4.01332 10.0933 4.07332 10.9867 4.66666 11.4933L9.11332 15.3467L15.4667 8.14001C16.0267 7.50001 15.9067 6.51334 15.2 6.04001L14.9933 5.90001C14.38 5.48667 13.5467 5.62001 13.0933 6.20001L8.92665 11.56L6.53999 9.38667C5.95332 8.85334 5.03999 8.90667 4.51999 9.50667Z"
          fill="#EB5107"
        />
        <path
          d="M3.22666 4.84664L2.39332 4.01331C2.04666 4.41331 1.73999 4.84664 1.45999 5.29997L2.51332 5.83331C2.72666 5.49331 2.96666 5.15997 3.22666 4.84664Z"
          fill="#EB5107"
        />
        <path
          d="M7.82668 1.9467L7.64001 0.780029C7.12001 0.906696 6.61335 1.07336 6.12668 1.28003L6.66668 2.3267C7.04001 2.18003 7.42668 2.0467 7.82668 1.9467Z"
          fill="#EB5107"
        />
        <path
          d="M9.99999 1.67333C10.1933 1.67333 10.38 1.68 10.5667 1.69333L10.7467 0.526667C10.5 0.506667 10.2533 0.5 9.99999 0.5C9.71332 0.5 9.43332 0.513333 9.15332 0.533333L9.33999 1.7C9.55999 1.68667 9.77999 1.67333 9.99999 1.67333Z"
          fill="#EB5107"
        />
        <path
          d="M5.30001 3.03336L4.76001 1.98669C4.30668 2.26669 3.88001 2.58003 3.48001 2.92669L4.31334 3.76003C4.62668 3.49336 4.95334 3.25336 5.30001 3.03336Z"
          fill="#EB5107"
        />
        <path
          d="M1.17333 10.5C1.17333 10.2933 1.18 10.0933 1.19333 9.88662L0.0266667 9.69995C0.0133333 9.96662 0 10.2333 0 10.5C0 10.78 0.0133333 11.06 0.0333333 11.3333L1.2 11.1466C1.18667 10.9333 1.17333 10.7133 1.17333 10.5Z"
          fill="#EB5107"
        />
        <path
          d="M12.2667 0.76001L12.0867 1.92668C15.9467 2.86668 18.8267 6.35334 18.8267 10.5C18.8267 15.3667 14.8667 19.3267 10 19.3267C5.88 19.3267 2.41333 16.4867 1.44667 12.6667L0.279999 12.8533C1.34 17.2333 5.29333 20.5 10 20.5C15.5133 20.5 20 16.0133 20 10.5C20 5.76668 16.6933 1.78668 12.2667 0.76001Z"
          fill="#EB5107"
        />
        <path
          d="M1.81333 7.20667L0.759996 6.67334C0.559996 7.16001 0.393329 7.66667 0.266663 8.18667L1.43333 8.37334C1.53333 7.97334 1.66 7.58001 1.81333 7.20667Z"
          fill="#EB5107"
        />
      </g>
      <defs>
        <clipPath id="clip0_86_112">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>

    <div class="grey--text text--darken-2 text-body-1 ml-2">
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.item-topic {
  display: grid;
  gap: 2px;
  grid-template-columns: 20px auto;
}
</style>
